'use strict';

var App = require('app');
var Strings = require('utils/strings');

var ActivationComponent = {};

ActivationComponent.initializeRouting = function () {
    new ActivationComponent.Router({
        controller: API,
    });
};

ActivationComponent.Router = App.BaseRouter.extend({
    appRoutes: {
        'activate/:type/:token': 'processActivation',
    },
});

var API = {
    processActivation: function (type, token) {
        var controller = require('components/activation/activation_controller');
        controller.processActivation(type, token);
    },
};

App.on('activation:show', function (type, token) {
    App.navigate(Strings.joinURL('activate', type, token));
    API.processActivation(type, token);
});

module.exports = ActivationComponent;
